import { useRouter } from "next/router";

const usePaginationParams = (pageKey = "page", sizeKey = "pageSize") => {
  const router = useRouter();
  const { query, pathname, isReady } = router;
  const pageSize = query[sizeKey] ? parseInt(query[sizeKey], 10) : 10;
  const page = query[pageKey] ? parseInt(query[pageKey], 10) : 0;

  const onPaginationModelChange = row => {
    const queryParams = {
      ...query,
      [pageKey]: row.pageIndex,
      [sizeKey]: row.pageSize,
    };

    router.replace({
      pathname,
      query: queryParams,
    });
  };

  const resetPaginationModal = () =>
    onPaginationModelChange({ pageIndex: 0, pageSize: 10 });

  const resetPaginationPage = () => {
    if (page == 0) return;
    onPaginationModelChange({ pageIndex: 0, pageSize });
  };

  return {
    page,
    pageSize,
    onPaginationModelChange,
    resetPaginationModal,
    resetPaginationPage,
    isPaginationParamsReady: isReady,
  };
};

export default usePaginationParams;
